export default "__VITE_ASSET__C1Rkv0ii__"